import toast from 'react-hot-toast';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Button } from '../components/ui';

const LOCAL_SENDING_KEY = 'lr-massenmail-sending-ids';
export const MASSENMAIL_SENDING_EVENT = 'lr-massenmail-sending-changed';

function progressToastId(id: string | number) {
  return `massenmail-send-progress-${id}`;
}

function doneToastId(id: string | number) {
  return `massenmail-send-done-${id}`;
}

function readLocalSendingIds(): number[] {
  try {
    const raw = sessionStorage.getItem(LOCAL_SENDING_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(Number).filter((n) => Number.isFinite(n)) : [];
  } catch {
    return [];
  }
}

function writeLocalSendingIds(ids: number[]) {
  sessionStorage.setItem(LOCAL_SENDING_KEY, JSON.stringify([...new Set(ids)]));
  window.dispatchEvent(new Event(MASSENMAIL_SENDING_EVENT));
}

export function getLocalSendingIds(): Set<number> {
  return new Set(readLocalSendingIds());
}

export function markElternbriefSending(id: string | number) {
  const next = readLocalSendingIds();
  next.push(Number(id));
  writeLocalSendingIds(next);
}

export function clearElternbriefSending(id: string | number) {
  writeLocalSendingIds(readLocalSendingIds().filter((item) => item !== Number(id)));
}

function StickyResultToast({
  toastId,
  message,
  tone
}: {
  toastId: string;
  message: string;
  tone: 'success' | 'error';
}) {
  return (
    <div
      className={
        tone === 'success'
          ? 'pointer-events-auto flex max-w-sm items-start gap-3 rounded-lg border-l-4 border-emerald-400 bg-gray-800 px-4 py-3 text-white shadow-lg dark:bg-gray-900'
          : 'pointer-events-auto flex max-w-sm items-start gap-3 rounded-lg border-l-4 border-red-400 bg-gray-800 px-4 py-3 text-white shadow-lg dark:bg-gray-900'
      }
    >
      <p className="flex-1 text-sm">{message}</p>
      <Button
        type="button"
        variant="ghost"
        size="xs"
        className="shrink-0 text-white hover:bg-white/10"
        aria-label="Meldung schließen"
        onClick={() => toast.dismiss(toastId)}
      >
        <XMarkIcon className="h-4 w-4" />
      </Button>
    </div>
  );
}

export function showElternbriefSendStarted(id: string | number) {
  markElternbriefSending(id);
  toast.loading(
    'Versand läuft. Sie können weiterarbeiten – Lernrakete meldet sich, wenn er fertig ist.',
    { id: progressToastId(id), duration: Infinity }
  );
}

export function showElternbriefSendFinished(
  id: string | number,
  message: string,
  ok: boolean
) {
  clearElternbriefSending(id);
  toast.dismiss(progressToastId(id));
  toast.custom(
    (t) => (
      <StickyResultToast
        toastId={t.id}
        message={message}
        tone={ok ? 'success' : 'error'}
      />
    ),
    { id: doneToastId(id), duration: Infinity }
  );
}
